<script setup lang="ts">

import Marketplace from '@presentation/Icons/Marketplace.vue';

</script>

<template>

    <Page>

        <ImageAndText 
            src="/WhatIsCarbucks/marketplace.png"
            image-class="max-w-[300px] drop-shadow-xl"
            animation="slide-up"
            flip
            floor-shadow>

            <Animated :delay="500" :duration="500" animation="slide-left">
                <Marketplace />
            </Animated>

            <h2 class="my-4">Marketplace</h2>
            <p class="font-normal text-white/80">
                We’ve partnered with over 1,500 trusted merchants to power a unique automotive 
                rewards program. 
            </p>

            <p class="font-normal text-white/80 mt-3">
                Every time your customers shop with these brands, they earn 
                real cashback—deposited straight into their account—turning everyday spending 
                into real automotive value.
            </p>

        </ImageAndText>

    </Page>

</template>